import { useApolloClient } from "@apollo/client";
export default function useDefaultFetchPolicy() {
    var _client_defaultOptions_watchQuery, _client_defaultOptions;
    const client = useApolloClient();
    return (_client_defaultOptions = client.defaultOptions) === null || _client_defaultOptions === void 0 ? void 0 : (_client_defaultOptions_watchQuery = _client_defaultOptions.watchQuery) === null || _client_defaultOptions_watchQuery === void 0 ? void 0 : _client_defaultOptions_watchQuery.fetchPolicy;
}

//# sourceMappingURL=useDefaultFetchPolicy.js.map